import { Component } from '@angular/core';
import { BasePluginMenuComponent } from './base.menu';

@Component({
    templateUrl: './edit-file.menu.html',
    standalone: false
})
export class EditFileMenuComponent extends BasePluginMenuComponent {}
